import validator from "validator";

const persianDigits = ["۰", "۱", "۲", "۳", "۴", "۵", "۶", "۷", "۸", "۹"];
const isInteger = (input: string) => {
  const enDigits = ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9"];
  const faDigits = [
    "۱",
    "۲",
    "۳",
    "۴",
    "۵",
    "۶",
    "۷",
    "۸",
    "۹",
    "۰",
    "\u0660",
    "\u0661",
    "\u0662",
    "\u0663",
    "\u0664",
    "\u0665",
    "\u0666",
    "\u0667",
    "\u0668",
    "\u0669",
  ];
  if (
    validator.isWhitelisted(input, enDigits) ||
    validator.isWhitelisted(input, faDigits)
  )
    return true;
  return false;
};
const convertNumbersInStringToEnglish = (input: string) => {
  const persianNumbers = [
    /۰/g,
    /۱/g,
    /۲/g,
    /۳/g,
    /۴/g,
    /۵/g,
    /۶/g,
    /۷/g,
    /۸/g,
    /۹/g,
  ];
  const arabicNumbers = [
    /٠/g,
    /١/g,
    /٢/g,
    /٣/g,
    /٤/g,
    /٥/g,
    /٦/g,
    /٧/g,
    /٨/g,
    /٩/g,
  ];
  let result = input;

  for (let i = 0; i < 10; i += 1) {
    result = result
      .replace(persianNumbers[i], i.toString())
      .replace(arabicNumbers[i], i.toString());
  }

  return result;
};
export const convertNumbersInStringToPersian = (input: string) => {
  const EnglishNumbers = [
    /0/g,
    /1/g,
    /2/g,
    /3/g,
    /4/g,
    /5/g,
    /6/g,
    /7/g,
    /8/g,
    /9/g,
  ];
  let result = input;
  for (let i = 0; i < 10; i += 1) {
    result = result.replace(EnglishNumbers[i], persianDigits[i]);
  }

  return result;
};

const getEnglishNumberOf = (input: string) => {
  if (input === "") return "";
  if (validator.isNumeric(input, { no_symbols: false })) return input;
  const toEnglish = convertNumbersInStringToEnglish(input);

  if (validator.isNumeric(toEnglish, { no_symbols: false })) return toEnglish;
  return "";
};

export { isInteger, getEnglishNumberOf, convertNumbersInStringToEnglish };
